/**
 * Formata um número de telefone completo.
 *
 * @param {string|number} ddi - DDI (código do país) sem o '+'
 * @param {string|number} phoneNumber - Número de telefone incluindo DDD e número local
 * @returns {string} O número formatado internacionalmente
 * @example "+55 (11) 91234-5678" ou "+1 1234567890"
 */

function formatPhoneNumber(ddi, phoneNumber) {
  if (!phoneNumber) return 'Número inválido';
  if (!ddi) return 'DDI inválido';
  try {
    const ddiClean = normalizeDDI(ddi);
    const phoneClean = normalizePhoneNumber(phoneNumber);

    if (phoneClean.length < 3) return 'Número incompleto';

    if (ddiClean === '55') {
      const ddd = phoneClean.substring(0, 2);
      const number = phoneClean.substring(2);
      return `+${ddiClean} (${ddd}) ${number.replace(
        /(\d{4,5})(\d{4})/,
        '$1-$2'
      )}`;
    } else return `+${ddiClean} ${phoneClean}`;
  } catch (error) {
    return `+${ddi} ${phoneNumber}` || '';
  }
}

/**
 * Normaliza um número de telefone removendo espaços, parênteses, sinais de mais e hífens.
 *
 * @param {string|number} phoneNumber - O número de telefone a ser normalizado.
 * @returns {string} O número de telefone normalizado contendo apenas dígitos.
 */

function normalizePhoneNumber(phoneNumber) {
  if (!phoneNumber) return '';
  return String(phoneNumber).replace(/[\s()-]/g, '');
}

/**
 * Normaliza um DDI (Discagem Direta Internacional) removendo todos os caracteres não numéricos.
 *
 * @param {string|number} ddi - O valor DDI a ser normalizado.
 * @returns {string} O DDI normalizado contendo apenas dígitos.
 */

function normalizeDDI(ddi) {
  if (!ddi) return '';
  return String(ddi).replace(/\D/g, '');
}

export { formatPhoneNumber, normalizePhoneNumber, normalizeDDI };
